/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('scene');
const SCENE_LIST = "SCENE_LIST";
const SCENE_ADD = "SCENE_ADD";
const SCENE_DELETE = "SCENE_DELETE";
const SCENE_EDIT = "SCENE_EDIT";
const SCENE_DETAIL = "SCENE_DETAIL";

export default {
    SCENE_LIST,
    sceneList : (search)=>{
        search.page = 1;
        search.pagesize = 100;
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:SCENE_LIST,
                data
            })
        })
    },
    SCENE_ADD,
    sceneAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:SCENE_ADD,
                data
            })
        })
    },
    SCENE_DELETE,
    sceneDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:SCENE_DELETE,
                data,
            })
        })
    },
    SCENE_EDIT,
    sceneEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:SCENE_EDIT,
                data,
            })
        })
    },
    SCENE_DETAIL,
    sceneDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:SCENE_DETAIL,
                data,
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/SceneAction.js